<po-page-default class="po-pb-2">
  <app-toaster></app-toaster>
  <div class="row po-font-text-small po-mb-3">
    <app-step-breadcrumb [breadcrumbs]="breadcrumbs" [activeIndex]="orderCountStep"
            (breadcrumbClick)="navigateBreadcrumb($event)"></app-step-breadcrumb>
  </div>
  
  <div class="po-row po-mb-1">
    <div class="po-xl-10 po-lg-10 po-md-9 po-sm-12">
      <p class="po-font-title">{{ countDescription }}</p>
    </div>
  </div>

  <div class="po-row po-mb-3">
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
      <po-container>
        <div class="details-grid">
          <div class="detail-item">
            <span class="detail-label">Número da Contagem:</span>
            <span class="detail-value">{{ countCode || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Descrição:</span>
            <span class="detail-value">{{ countDescription }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Data:</span>
            <span class="detail-value">{{ createdDate }}</span>
          </div>
        </div>
      </po-container>
    </div>
  </div>

  <div class="po-row">
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
      <po-container>
        <div class="po-row" *ngIf="!isFinished">
          <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-pl-2 po-pr-2">
            <po-input
              [(ngModel)]="inputQuantity"
              p-label="Quantidade a ser lida"
              p-type="number"
              p-icon="po-icon-plus"
              (p-change)="validateInputQuantity()">
            </po-input>
          </div>
        </div>
        <div class="po-row" *ngIf="!isFinished">
          <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
            <app-scanner (scannedData)="onScannedData($event)" p-label="Ler código do produto"></app-scanner>
          </div>
        </div>
        <div class="po-row" *ngIf="isFinished">
          <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
            <div class="finished-status-container">
              <span class="status-label">Status:</span>
              <span class="conference-status-badge" [ngClass]="getConferenceStatusInfo(countStatus).class">
                <i class="po-icon" [class]="getConferenceStatusInfo(countStatus).icon"></i>
                <span class="po-ml-1">{{ getConferenceStatusInfo(countStatus).text }}</span>
              </span>
            </div>
          </div>
        </div>
      </po-container>
    </div>
  </div>

      <div class="po-row po-mt-3">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <po-container>
            <div class="po-row po-mb-2">
              <div class="po-xl-6 po-lg-6 po-md-6 po-sm-12">
                <span class="po-font-text-large-bold section-title">Itens Conferidos</span>
              </div>
              <div class="po-xl-6 po-lg-6 po-md-6 po-sm-12 po-text-right">
                <span class="po-font-text-large-bold totals-text">Total de itens: {{ itemsConferidos.length }} | Total de peças: {{ getTotalQuantity() }}</span>
              </div>
            </div>

            <div *ngIf="itemsConferidos.length === 0" class="po-text-center po-mb-2">
              <div class="empty-state">
                Nenhum item conferido ainda
              </div>
            </div>

            <div class="item-card po-mb-2" *ngFor="let item of itemsConferidos">
              <div class="item-header">
                <div class="item-info">
                  <div class="info-row">
                    <span class="info-label">Código:</span>
                    <span class="info-value">{{ item.number }}</span>
                  </div>
                  <div class="info-row" *ngIf="item.batchBarCode">
                    <span class="info-label">Lote:</span>
                    <span class="info-value">{{ item.batchBarCode }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Descrição:</span>
                    <span class="info-value">{{ item.description }}</span>
                  </div>
                </div>
                <div class="item-actions">
                  <div class="quantity-container">
                    <span class="quantity-label">Qtd:</span>
                    <span class="quantity-badge">{{ item.conferred }}</span>
                  </div>
                  <po-button
                    *ngIf="!isFinished"
                    p-icon="po-icon-delete"
                    p-kind="danger"
                    p-size="small"
                    (p-click)="removeItem(item)">
                  </po-button>
                </div>
              </div>
            </div>
          </po-container>
        </div>
      </div>

      <div class="po-row po-mt-3" *ngIf="itemsConferidos.length > 0 && !isFinished">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mb-2">
          <po-button
            p-label="Finalizar Contagem"
            p-kind="primary"
            class="po-md-12"
            (p-click)="finishCount()">
          </po-button>
        </div>
  </div>
</po-page-default>
